import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  VERIFYOTP_INIT_ACTION,
  VERIFYOTP_SUCCESS_ACTION,
  VERIFYOTP_FAIL_ACTION,
  RESENDVERIFYOTP_INIT_ACTION,
  RESENDVERIFYOTP_SUCCESS_ACTION,
  RESENDVERIFYOTP_FAIL_ACTION,
} from "./action";
import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import { push } from "connected-react-router";
import "react-toastify/dist/ReactToastify.css";

function* verifyOTP(value) {
   try {
    const token = localStorage.getItem("token"); 
    const data = {
      pin:value.value
    };
    const res = yield fetch(`${appConfig.ip}/phoneVerify/checkpin`, {
      method: "POST",
      headers: {
        "Content-Type":"application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      // console.log(resJSON);

      if(resJSON.ok===true){
        yield put({
          type: VERIFYOTP_SUCCESS_ACTION,
          payload: resJSON,
        });
  
        yield toast.success("OTP Verified", {
          autoClose: 3000,
          transition:Flip
        });
        
        // Check if user is employee - if so, go to dashboard; otherwise go to update profile
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        if (userDetails && userDetails.role === "employee") {
          yield put(push("/dashboard"));
        } else {
          yield put(push("/updateprofile"));
        }
      }else {
        yield put({
          type: VERIFYOTP_FAIL_ACTION,
          payload: resJSON,
        });
  
        yield toast.error("Invalid OTP", {
          autoClose: 3000,
          transition:Flip
        });
      }
      
    }
  } catch (err) {
    if (err.status === 404) {
      yield toast.error("OTP Expired", {
        autoClose: 3000,
        transition:Flip
      });
    }

    yield put({
      type: VERIFYOTP_FAIL_ACTION,
      payload: err,
    });
  }
}

function* resendverifyOTP(value) {
  try {
   const token = localStorage.getItem("token"); 
   const data = {};
   const res = yield fetch(`${appConfig.ip}/phoneVerify/resendotp`, {
     method: "POST",
     headers: {
       "Content-Type":"application/json",
       "Authorization": `Bearer ${token}`
     },
     body: JSON.stringify(data)
   });

   if (!res.ok) {
     throw res;
   } else {
     const resJSON = yield res.json();
    //  console.log(resJSON);

     if(resJSON.ok===true){
       yield put({
         type: RESENDVERIFYOTP_SUCCESS_ACTION,
         payload: resJSON,
       });
 
       yield toast.success("OTP resent", {
         autoClose: 3000,
         transition:Flip
       });
     }else {
       yield put({
         type: RESENDVERIFYOTP_FAIL_ACTION,
         payload: resJSON,
       });
 
       yield toast.error("We are facing issues on resending the OTP. OTP may have expired", {
         autoClose: 3000,
         transition:Flip
       });
     }
     
   }
 } catch (err) {
   if (err.status === 404) {
     yield toast.error("OTP Expired", {
       autoClose: 3000,
       transition:Flip
     });
   }

   yield put({
     type: RESENDVERIFYOTP_FAIL_ACTION,
     payload: err,
   });
 }
}

export function* VerifyOTPActionWatcher() {
  yield takeEvery(VERIFYOTP_INIT_ACTION, verifyOTP);
  yield takeEvery(RESENDVERIFYOTP_INIT_ACTION, resendverifyOTP);
}
